import { Icon, SpacerH } from '@cb/apricot-react'
import styles from './errors.module.scss'

function FormErrorMsg({ error, id }) {
  return (
    <div className={styles['form-error']} id={id}>
      <Icon name="exclamation" size="24" color="red1" circular />
      <SpacerH size="8" />
      {error}
    </div>
  )
}

export default FormErrorMsg
